const createSh060InitState = () => ({
  orderInfo: {},
  descriptionInfo: {},
  realAuthoriFlg: 1,
  creditInpNumOption: 0,
});

const createSh060RequestState = () => ({
  cardSaveFlg: 0,
  agreeFlag: 0,
  hopeDayList: [],
  hopeDayCntList: [],
  hopeDay: '',
  hopeDayCnt: '',
  cardFlg: 0,
  biko: '',
  giftCd: '0',
  sagyoKanriKomokuCd: '',
  sagyoKanriKomokuCd2: '',
  noshiNaire1: '',
  noshiNaire2: '',
});

const state = () => ({
  sh060Init: createSh060InitState(),
  sh060Request: createSh060RequestState(),
});

const mutations = {
  RESET_SH060_STATE(currentState) {
    currentState.sh060Init = createSh060InitState();
    currentState.sh060Request = createSh060RequestState();
  },
  SET_SH060_INIT(currentState, payload = {}) {
    currentState.sh060Init = payload || {};
  },
  MERGE_SH060_INIT(currentState, payload = {}) {
    currentState.sh060Init = Object.assign({}, currentState.sh060Init, payload);
  },
  SET_SH060_REQUEST(currentState, payload = {}) {
    currentState.sh060Request = payload || {};
  },
  MERGE_SH060_REQUEST(currentState, payload = {}) {
    currentState.sh060Request = Object.assign({}, currentState.sh060Request, payload);
  },
};

const getters = {
  sh060Init: currentState => currentState.sh060Init,
  sh060Request: currentState => currentState.sh060Request,
};

export {
  createSh060InitState,
  createSh060RequestState,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
